import { render, staticRenderFns } from "./layout-combined-default.vue?vue&type=template&id=b2215286&scoped=true&"
import script from "./layout-combined-default.vue?vue&type=script&lang=js&"
export * from "./layout-combined-default.vue?vue&type=script&lang=js&"
import style0 from "./layout-combined-default.vue?vue&type=style&index=0&id=b2215286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2215286",
  null
  
)

export default component.exports